var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import Select from "@mui/joy/Select";
import Option from "@mui/joy/Option";
import { useTranslation } from "react-i18next";
export var BorderColor = function (_a) {
    var field = _a.field, value = _a.value, baseColor = _a.baseColor, paletteColors = _a.paletteColors, onChange = _a.onChange;
    var t = useTranslation("Administration").t;
    var currentColor = value.source === "base" ? baseColor : paletteColors === null || paletteColors === void 0 ? void 0 : paletteColors[Number(value.value)];
    var borderColorLabels = {
        border_color_top: "LBL_BORDER_COLOR_TOP",
        border_color_bottom: "LBL_BORDER_COLOR_BOTTOM",
        border_color_left: "LBL_BORDER_COLOR_LEFT",
        border_color_right: "LBL_BORDER_COLOR_RIGHT",
    };
    var labelKey = borderColorLabels[field];
    return (_jsxs("div", __assign({ className: "flex items-center mb-1" }, { children: [_jsxs("span", __assign({ className: "mr-4 w-20" }, { children: [t(labelKey), ":"] })), _jsxs("div", __assign({ className: "flex items-center gap-4" }, { children: [_jsxs("select", __assign({ className: "border rounded px-4 py-2 ".concat(value.source === "base" && baseColor
                            ? "bg-".concat(baseColor, "-400 dark:bg-").concat(baseColor, "-700")
                            : ""), style: value.source === "palette"
                            ? {
                                backgroundColor: (paletteColors === null || paletteColors === void 0 ? void 0 : paletteColors[Number(value.value)]) || "#3b82f6",
                            }
                            : undefined, value: value.source, onChange: function (e) {
                            var source = e.target.value;
                            onChange(field, {
                                source: source,
                                value: source === "palette" ? 0 : baseColor,
                            });
                        } }, { children: [_jsx("option", __assign({ value: "base" }, { children: t("LBL_THEME_BASE_COLOR") })), _jsx("option", __assign({ value: "palette" }, { children: t("LBL_COLOR_PALETTE") }))] })), value.source === "palette" && (_jsx(Select, __assign({ value: Number(value.value), onChange: function (_, index) {
                            onChange(field, {
                                source: "palette",
                                value: Number(index),
                            });
                        }, className: "w-[150px]", sx: {
                            background: currentColor,
                            "&:hover": {
                                background: currentColor,
                            },
                        } }, { children: paletteColors.slice(0, 20).map(function (color, index) { return (_jsx(Option, __assign({ value: index }, { children: _jsxs("div", __assign({ style: {
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px",
                                } }, { children: [_jsx("div", { style: {
                                            width: "16px",
                                            height: "16px",
                                            borderRadius: "50%",
                                            backgroundColor: color,
                                        } }), color] })) }), index)); }) })))] }))] })));
};
